import { getjQuery, resolveUrl } from "@serenity-is/corelib";
import { SiteFormTexts } from "../../ServerTypes/Texts";

export class IdleTimeout {

    static defaults = {
        activityEvents: 'click keyup mouseup mousemove scroll touchend touchmove wheel mousewheel',
        activityTimeout: 700 * 60,
        checkInterval: 5,
        keepAliveTimer: 300,
        keepAliveUrl: '~/Account/KeepAlive',
        signoutUrl: '~/Account/Signout',
        warningDuration: 2 * 60,
    };

    private options;
    private idleTimer;
    private keepAliveTimer;
    private warningTimer;
    private remainingTimer;
    constructor(options: any) {
        var _this = this;
        var $ = getjQuery();
        this.options = $.extend({}, IdleTimeout.defaults, options);
        localStorage.setItem('IdleTimeout:LastActivity', $.now().toString());
        localStorage.removeItem('IdleTimeout:Signout');
        var mouseX, mouseY;
        $('body').on(options.activityEvents, function (e) {
            if (e.type == 'mousemove') {
                if (e.clientX == mouseX && e.clientY == mouseY)
                    return;
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            if (!_this.isWarningActive()) {
                _this.resetIdleTimer();
            }
        });
        if (options.keepAliveTimer)
            this.startKeepAliveTimer();
        this.resetIdleTimer();
    }

    private startKeepAliveTimer() {
        var $ = getjQuery();
        var _this = this;
        clearTimeout(this.keepAliveTimer);
        var keepSessionAlive = function () {
            $.get(resolveUrl(this.options.keepAliveUrl) + '?' + new Date().getTime());
            _this.startKeepAliveTimer();
        };
        this.keepAliveTimer = setTimeout(keepSessionAlive, this.options.keepAliveTimer * 1000);
    };
    private isWarningActive() {
        var $ = getjQuery();
        return $('#idle-timeout-warning').is(':visible');
    };
    private startWarningTimer() {
        var _this = this;
        this.warningTimer = setInterval(function () { return _this.warningTimeout(); }, this.options.checkInterval * 1000);
    };
    private stopWarningTimer() {
        clearInterval(this.warningTimer);
        clearInterval(this.remainingTimer);
    };
    private warningTimeout() {
        if (this.getRemainingSeconds() < 0)
            this.signout();
    };
    private resetIdleTimer() {
        var $ = getjQuery();
        clearTimeout(this.idleTimer);
        localStorage.setItem('IdleTimeout:LastActivity', $.now().toString());
        this.idleTimeout();
    };
    private idleTimeout() {
        var _this = this;
        this.checkActivityTimeout();
        this.idleTimer = setTimeout(function () { return _this.idleTimeout(); }, this.options.checkInterval * 1000);
    };
    private checkActivityTimeout() {
        var $ = getjQuery();
        var timeLimit = parseInt(localStorage.getItem('IdleTimeout:LastActivity') || $.now().toString()) +
            (this.options.activityTimeout - (this.options.warningDuration || 0)) * 1000;
        if ($.now() > timeLimit) {
            if (!this.options.warningDuration) {
                this.signout();
            }
            else {
                this.showWarning();
                this.startWarningTimer();
            }
        }
        else if (localStorage.getItem('IdleTimeout:Signout')) {
            this.signout();
        }
        else if (this.isWarningActive()) {
            this.closeWarning();
            this.stopWarningTimer();
        }
    };
    private signout() {
        localStorage.setItem('IdleTimeout:Signout', "1");
        clearTimeout(this.keepAliveTimer);
        this.stopWarningTimer();
        this.closeWarning();
        this.options.beforeSignout && this.options.beforeSignout();
        if (this.options.signoutUrl)
            window.location.href = resolveUrl(this.options.signoutUrl);
    };
    private showWarning() {
        var $ = getjQuery();
        var _this = this;
        var warningDialog = $('#idle-timeout-warning');
        if (!warningDialog.length) {
            warningDialog = $(`
<div class="modal fade" id="idle-timeout-warning">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">${SiteFormTexts.Idle.WarningTitle}</h4>
            </div>
            <div class="modal-body">
                <p>${SiteFormTexts.Idle.WarningMessage}</p>
                <p>${SiteFormTexts.Idle.CountdownMessage}</p>
                <div class="progress">
                    <div id="idle-timeout-progress" class="progress-bar progress-bar-striped active" role="progressbar" style="min-width: 15px; width: 100%;"></div>
                </div>
            <div class="modal-footer">
                    <button id="idle-timeout-warning-signout" type="button" class="btn btn-danger"> ${SiteFormTexts.Idle.SignoutButton}</button>
                    <button id="idle-timeout-warning-keepalive" type="button" class="btn btn-primary" data-dismiss="modal"> ${SiteFormTexts.Idle.KeepAliveButton}</button>
            </div>
        </div>
    </div>
</div>
            `).appendTo(document.body);
            $('#idle-timeout-warning-signout').on('click', function () { return _this.signout(); });
            warningDialog.on('hide.bs.modal', function () {
                clearTimeout(_this.warningTimer);
                clearTimeout(_this.remainingTimer);
                _this.resetIdleTimer();
            });

            $('#idle-timeout-warning-keepalive').on('click', () => {
                this.resetIdleTimer();
                clearTimeout(this.keepAliveTimer);
                this.stopWarningTimer();
                this.closeWarning();
                warningDialog['modal']('hide');
            });
        }
        warningDialog['modal']('show');
        this.countdownDisplay();
    };
    private closeWarning() {
        var $ = getjQuery();
        var warning = $('#idle-timeout-warning').off('hide.bs.modal');
        if (warning.length && warning.data() && warning.data()['bs.modal'] && warning.data()['bs.modal'].isShown) {
            warning.removeClass('fade');
            warning['modal']('hide');
            warning.remove();
        }
    };
    private getRemainingSeconds() {
        var $ = getjQuery();
        var timeLimit = parseInt(localStorage.getItem('IdleTimeout:LastActivity') || $.now().toString()) +
            (this.options.activityTimeout * 1000);
        return Math.ceil(((timeLimit - $.now()) / 1000));
    };
    private countdownDisplay() {
        var $ = getjQuery();
        var _this = this;
        clearTimeout(this.remainingTimer);
        var update = function () {
            var remainingSeconds = Math.max(_this.getRemainingSeconds(), 1);
            var percentLeft = 100 * Math.max(1, remainingSeconds) / (_this.options.warningDuration || 1);
            $('#idle-timeout-progress').css('width', percentLeft + '%');
            $('#idle-timeout-seconds').text(remainingSeconds);
        };
        this.remainingTimer = setInterval(update, 500);
        update();
    };
}
